module.exports = __webpack_public_path__ + "img/uyumsoft2025.bdc45989.png";